// extracted by mini-css-extract-plugin
export var actionButton = "_if-t";
export var buttonContainer = "_if-0";
export var buttonContainer2 = "_if-1";
export var buttonSection = "_if-2";
export var details = "_if-3";
export var dropdownItem = "_if-5";
export var dropdownItemsContainer = "_if-4";
export var fileInput = "_if-r";
export var headerButton = "_if-6";
export var icon = "_if-7";
export var input = "_if-8";
export var macroListItem = "_if-9";
export var mainContent = "_if-a";
export var microText = "_if-b";
export var modal = "_if-w";
export var optionsButton = "_if-c";
export var paperclip = "_if-s";
export var pillContent = "_if-d";
export var preview = "_if-e";
export var preview2 = "_if-f";
export var quillEditor = "_if-q";
export var selectedMacro = "_if-g";
export var sidebar = "_if-h";
export var sidebarHeader = "_if-j";
export var sidebarList = "_if-i";
export var sidebarListItem = "_if-k";
export var sidebarSearch = "_if-l";
export var snoozeDurationWrapper = "_if-v";
export var statusPillContainer = "_if-m";
export var tagsContainer = "_if-n";
export var unselectedMacro = "_if-o";
export var variable = "_if-u";
export var wrapper = "_if-p";